<div class="download-form">
	<h2>Ajouter des vidéos</h2>

	<fieldset class="download-form__mode">
		<legend>Mode</legend>
		<label><input type="radio" name="mode" value="video" checked /> Vidéo</label>
		<label><input type="radio" name="mode" value="audio" /> Audio</label>
		<label><input type="radio" name="mode" value="thumbnail" /> Miniature seule</label>
	</fieldset>

	<div class="download-form__options" data-mode-options="video">
		<label><input type="checkbox" data-field="subtitles" /> Sous-titres (fr/en)</label>
		<label><input type="checkbox" data-field="embedThumbnail" /> Miniature embarquée</label>
	</div>
	<div class="download-form__options" data-mode-options="audio" hidden>
		<label>
			Format
			<select data-field="audioFormat">
				<option value="mp3">MP3</option>
				<option value="m4a">M4A</option>
				<option value="opus">Opus</option>
			</select>
		</label>
	</div>

	<form class="download-form__form" data-form="url">
		<label class="download-form__field">
			URL (vidéo ou playlist)
			<input type="url" name="url" placeholder="https://www.youtube.com/..." required />
		</label>
		<button type="submit">Ajouter</button>
	</form>
	<p class="download-form__error" data-role="url-error" hidden></p>

	<hr />

	<form class="download-form__form" data-form="search">
		<label class="download-form__field">
			Recherche YouTube
			<input type="text" name="query" placeholder="Mots-clés" maxlength="200" required />
		</label>
		<label class="download-form__field download-form__field--narrow">
			Limite (optionnel)
			<input type="number" name="limit" min="1" max="1000" step="1" inputmode="numeric" placeholder="Illimité" />
		</label>
		<button type="submit">Rechercher</button>
	</form>
	<p class="download-form__error" data-role="search-error" hidden></p>

	<form class="download-form__form" data-form="channel">
		<label class="download-form__field">
			Chaîne (@handle ou URL)
			<input type="text" name="channel" placeholder="@nomdelachaine" required />
		</label>
		<label class="download-form__field">
			Section
			<select name="section">
				<option value="videos">Vidéos</option>
				<option value="streams">Streams</option>
			</select>
		</label>
		<label class="download-form__field">
			Mots-clés (optionnel, séparés par des virgules)
			<input type="text" name="keywords" placeholder="mot-clé1, mot-clé2" />
		</label>
		<button type="submit">Rechercher</button>
	</form>
	<p class="download-form__error" data-role="channel-error" hidden></p>

	<div class="download-form__results-header" data-role="results-header" hidden>
		<p class="download-form__status" data-role="results-status"></p>
		<button type="button" class="secondary" data-role="add-all" hidden>Tout ajouter à la file</button>
		<p class="download-form__error" data-role="results-error" hidden></p>
	</div>

	<ul class="download-form__results" data-role="results"></ul>
</div>
